import type { BaseMessage } from "@sendbird/chat/message"
import { create } from "zustand"

interface SBStore {
  messageToReplyTo: BaseMessage | null
  setMessageToReplyTo: (message: BaseMessage | null) => void

  messageToEdit: BaseMessage | null
  setMessageToEdit: (message: BaseMessage | null) => void

  inputText: string
  setInputText: (text: string) => void

  isLoadingSuggestions: boolean
  setIsLoadingSuggestions: (isLoading: boolean) => void

  attachments: File[]
  setAttachments: (attachments: File[]) => void
}

export const useSBStore = create<SBStore>((set) => ({
  messageToReplyTo: null,
  setMessageToReplyTo: (message) => set({ messageToReplyTo: message }),

  messageToEdit: null,
  setMessageToEdit: (message) => set({ messageToEdit: message }),

  inputText: "",
  setInputText: (text) => set({ inputText: text }),

  isLoadingSuggestions: false,
  setIsLoadingSuggestions: (isLoading) =>
    set({ isLoadingSuggestions: isLoading }),

  attachments: [],
  setAttachments: (attachments) => set({ attachments }),
}))
